/* eslint-disable no-unused-vars */
import { apolloClient } from '@/setup/apollo-setup'

import {
  SIGN_IN,
  RESET_KEY,
  SIGN_OUT,
  OTP_RESET,
  GET_CURRENT_USER,
  GET_NAVE_MENU_ITEM,
  GET_PERMISSIONS,
} from '@/queries/core'

import {
  serverResponseStatus,
  error,
  } from '@/utils/notification'

export function setLanguage ({ commit }, payload) {
  if (process.env.NODE_ENV === 'development') {
    console.log('$store/setLanguage', payload) // eslint-disable-line no-console
  }
  commit('changeLanguage', payload)
}

export async function initializeData (context) {
  const version = process.env.VUE_APP_PACKAGE_VERSION
  console.log(`Application Version ${version}`) // eslint-disable-line no-console
  console.log('Initializing Data...') // eslint-disable-line no-console

  const token = localStorage.getItem('token')
  if (token) {
    try {
      context.commit('clearError')
      context.commit('setProcessing', true)
      try {
        context.dispatch('getNavMenuItems').then();
        context.dispatch('getPermissions').then();

        context.dispatch('Master/getOccupations').then();
        context.dispatch('Master/getSigners').then();
        // context.dispatch('Master/getPeriods').then();
        // context.dispatch('Master/getDegrees').then();
        // context.dispatch('Master/getProjects').then();
        // context.dispatch('Master/getFaculties').then();
        // context.dispatch('Master/getCurriculums').then();
        // context.dispatch('Master/getPrefixes').then();
        // context.dispatch('Prosecution/getLawyers').then();
        // context.dispatch('Master/getNationalities')
        // context.dispatch('Master/getRaces')
        // context.dispatch('Master/getReligions')
        context.commit('setSuccess', null)
      } catch (e) {
        console.log(e); // eslint-disable-line no-console
        context.commit('setError', error(e.toString(), null));
      }
    } catch (e) {
      console.log(e) // eslint-disable-line no-console
      context.commit('setError', error(e))
    }
  }

}

export async function getNavMenuItems ({ commit }) {
  // console.log('Get NavMenuItems...')

  commit('clearError')
  commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_NAVE_MENU_ITEM,
        fetchPolicy: 'network-only'
      })

    const { data } = await response
    const { getNaveMenuItem } = data

    commit('setNavMenuItems', getNaveMenuItem)
    commit('setSuccess', null)

  } catch (e) {
    console.log(e); // eslint-disable-line no-console
    commit('setError', null)
  }
}

export async function getPermissions ({ commit }) {
  // console.log('Get Permissions...')

  commit('clearError')
  commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_PERMISSIONS,
        fetchPolicy: 'network-only'
      })

    const { data } = await response
    const { getPermissions } = data

    commit('setPermissions', getPermissions)
    commit('setSuccess', null)

  } catch (e) {
    console.log(e); // eslint-disable-line no-console
    commit('setError', null)
  }
}

export async function signIn (context, payload) {
  //console.log('SignIn...')
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {...payload.credential}

    const response = await apolloClient
      .mutate({
        mutation: SIGN_IN,
        variables,
        fetchPolicy: 'no-cache'
      })

    const { data } = await response
    const { signIn } = data;
    const { token, user } = signIn;
    const { oneTimePasswordReset, role } = user;
    const { isSale, type } = role;

    context.commit('setToken', token)
    context.commit('setCurrentUser', user)
    await context.dispatch('getNavMenuItems')
    await context.dispatch('getPermissions')
    context.commit('setSuccess', serverResponseStatus('notification.authentication-success-title', {
      status: {success: true, error: false, message: 'notification.authentication-success-message'}
    }))

    setTimeout(() => {
      if(oneTimePasswordReset) {
        if (isSale){
          payload.vm.$router.push("/accounting/contract");
        }else if(type === 'lawyer'){
          payload.vm.$router.push("/prosecution/lawyerJob");
        }else{
          payload.vm.$router.push("/");
        }

      } else {
        payload.vm.$router.push("/auth/reset-password")
      }
    }, 1000);
  } catch (e) {
    console.log(e) // eslint-disable-line no-console
    context.commit('setError', serverResponseStatus('notification.authentication-error-title', {
      status: {success: false, error: true, message: 'notification.authentication-error-message'}
    }))
  }
}

export async function resetKey (context, payload) {
  //console.log('SignIn...') // eslint-disable-line no-console
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {...payload.credential}

    const response = await apolloClient
      .mutate({
        mutation: RESET_KEY,
        variables,
        fetchPolicy: 'no-cache'
      })

    const { data } = await response


    await context.commit('setToken',  data.resetKey.token)
    await context.commit('setCurrentUser', data.resetKey.user)
    context.commit('setSuccess', serverResponseStatus('notification.authentication-success-title', {
      status: {success: true, error: false, message: 'notification.authentication-success-message'}
    }))

    setTimeout(() => {
      payload.vm.$router.push("/auth/reset-password")
    }, 200);
  } catch (e) {
    console.log(e) // eslint-disable-line no-console
    context.commit('setError', serverResponseStatus('notification.authentication-error-title', {
      status: {success: false, error: true, message: 'notification.authentication-error-message'}
    }))
    setTimeout(() => {
      payload.vm.$router.push("/pages/page-error-404")
    }, 200);
  }
}

export async function signOut (context, vm) {
  // console.log('Signing Out...') // eslint-disable-line no-console

  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    context.commit('setLogoutStatus')
    await vm.$router.push('/auth/login')
    // const response = await apolloClient
    //   .mutate({
    //     mutation: SIGN_OUT
    //   })
    //
    // const { data } = await response
    // context.commit('setLogoutStatus')
    // context.commit('setSuccess', null)
    //
    // setTimeout(() => {
    //   if (vm) {
    //     vm.$router.push('/auth/login')
    //   } else if (window.location.pathname !== '/') {
    //     window.location = '/auth/login'
    //   } else {
    //     window.location = `${process.env.BASE_URL  }auth/login`
    //   }
    // }, 2000)
  } catch (e) {
    console.log(e) // eslint-disable-line no-console
    context.commit('setError', error(e.toString(), null));
  }
}

export async function otpReset (context, payload) {
  console.log('Reset Password...') // eslint-disable-line no-console

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    newPassword: payload.form.newPassword
  }
  // console.log(variables);
  try {
    const response = await apolloClient
      .mutate({
        mutation: OTP_RESET,
        variables
      })

    const { data } = await response
    const { otpReset } = data;
    context.commit('setCurrentUser', otpReset)
    context.commit('setSuccess', serverResponseStatus('notification.otp-reset-success-title', {
      status: {success: true, error: false, message: 'notification.otp-reset-success-message'}
    }))
      setTimeout(() => {
        payload.vm.$router.push("/")
      }, 200);
  } catch (e) {
    console.log(e) // eslint-disable-line no-console
    context.commit('setError', error(null, null))
  }
}

export async function initUser (context, payload) {
  const token = localStorage.getItem('token')
  if (token) {
    try {
      // console.log('User data is initializing')
      context.commit('clearError')
      context.commit('setProcessing', true)
      const result = await apolloClient.query({
        query: GET_CURRENT_USER,
        fetchPolicy: 'network-only'
      })
      const { data } = result
      const { getCurrentUser } = data

      context.commit('setCurrentUser', getCurrentUser)
    } catch (e) {
      console.log(e) // eslint-disable-line no-console
      context.commit('setError', error(e))
    }
  }
}

export async function authenticationError (context) {
  console.log('Authentication Error...') // eslint-disable-line no-console

  context.commit('clearError')
  context.commit('setProcessing', true)

  context.commit('setLogoutStatus')
  context.commit('setSuccess', null)

  setTimeout(() => {
    if (window.location.pathname !== '/auth/login') {
      window.location = '/auth/login'
    }
  }, 1000)
}



